export const en = {
    transaction_history: 'Transaction history',
};
